import React, { useEffect, useContext, useRef, useMemo, useState } from 'react'
import { DataContext } from '../DataContext'
import { xScale, yScale } from '../utility/scales'

const Tooltip = ({ toolTipOptions, points, containerDimensions }) => {
    const { cx, cy } = toolTipOptions
    const roughToolTipSize = 52 * points.length
    const tooltipYPosition = cy - roughToolTipSize / 2
    const containerHeight = containerDimensions.height
    const howManyUnitsIsTooltipOutsideOfContainerInY = (tooltipYPosition + roughToolTipSize) - containerHeight

    return (
        points.length > 0 && (
            <foreignObject
                x={cx + 12}
                y={tooltipYPosition - (howManyUnitsIsTooltipOutsideOfContainerInY > 0 ? howManyUnitsIsTooltipOutsideOfContainerInY : 0)}
                width={1000}
                height={1000}
                overflow="visible"
                style={{
                    overflow: 'visible',
                    position: 'absolute',
                    transform: 'translate(0, 0)',
                    clipPath: 'none',
                }}
            >
                <div
                    className="customTooltip"
                    style={{
                        position: 'relative',
                        backgroundColor: 'white',
                        padding: '8px',
                        border: '1px solid #ddd',
                        borderRadius: '4px',
                        boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
                        maxWidth: 'fit-content',
                        maxWeight: 'fit-content',
                        overflow: 'hidden',
                        boxSizing: 'border-box',
                    }}
                >
                    <ul className="customTooltipList">
                        {points.map((point, i) => {
                            return (
                                <li
                                    key={i}
                                    className={'piperTooltip'}
                                    // className={`${
                                    //     isExpanded
                                    //         ? `boxPlotTooltipExpanded`
                                    //         : `boxPlotTooltip`
                                    // }`}
                                >
                                    <div
                                        style={{
                                            backgroundColor: point.color.fill,
                                            height: 18,
                                            width: 18,
                                            border: `2px solid ${point.color
                                                .stroke || 'white'}`,
                                            borderRadius: 10,
                                            float: 'left',
                                            marginRight: 5,
                                        }}
                                    />
                                    <span className="customTooltipItemName customTooltipItemValue">
                                        {point.FacilityTypeDisplay}
                                    </span>
                                    <div>
                                        {point.percentages &&
                                            Object.keys(point.percentages).map(
                                                (p, idx) => {
                                                    const per =
                                                        point.percentages[p]
                                                    return (
                                                        <span className="">
                                                            <strong>
                                                                {p}:{' '}
                                                            </strong>
                                                            {per.toFixed(2)}% {idx + 1 < Object.keys(point.percentages).length && <strong>{` | `}</strong>}
                                                        </span>
                                                    )
                                                }
                                            )}
                                    </div>
                                </li>
                            )
                        })}
                    </ul>
                </div>
            </foreignObject>
        )
    )
}

const Points = ({ dataPoints = [] }) => {
    const { containerDimensions } = useContext(DataContext)
    const [displayTooltip, setDisplayTooltip] = useState(null)
    const [nearbyPoints, setNearbyPoints] = useState([])

    // Function to find points near the hovered point
    const findNearbyPoints = (hoveredPoint, allPoints) => {
        const threshold = 20 // pixels distance threshold
        return allPoints.filter(point => {
            const pointX = xScale(point.x, containerDimensions.width)
            const pointY = yScale(point.y, containerDimensions.height)
            const distance = Math.sqrt(
                Math.pow(pointX - hoveredPoint.cx, 2) +
                    Math.pow(pointY - hoveredPoint.cy, 2)
            )
            return distance <= threshold
        })
    }

    return (
        <>
            {dataPoints.map((d, idx) => {
                const cx = xScale(d.x, containerDimensions.width)
                const cy = yScale(d.y, containerDimensions.height)
                return (
                    (cx || cy) && (
                        <circle
                            cx={cx}
                            cy={cy}
                            r={5}
                            {...d.color}
                            onMouseMove={e => {
                                const nearby = findNearbyPoints(
                                    { cx, cy },
                                    dataPoints
                                )

                                setNearbyPoints(nearby)
                                setDisplayTooltip({
                                    cx,
                                    cy,
                                })
                            }}
                            onMouseLeave={() => {
                                setDisplayTooltip(null)
                                setNearbyPoints([])
                            }}
                        />
                    )
                )
            })}
            {displayTooltip && nearbyPoints.length > 0 && (
                <Tooltip
                    toolTipOptions={displayTooltip}
                    points={nearbyPoints}
                    containerDimensions={containerDimensions}
                />
            )}
        </>
    )
}

export default Points
